/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcCorpactionsCaadminV1ActionEvent } from '@interxfi/types';
import { schema } from 'normalizr';
import { ixcAssetsV1AssetStateEntity } from './ixc-assets-v1-asset-state';

export const IXC_CORPACTIONS_CAADMIN_V1_ACTION_EVENT_ENTITY_NAME = 'ixc.corpactions.caadmin.v1.ActionEvent';
export const ixcCorpactionsCaadminV1ActionEventEntity = new schema.Entity<IxcCorpactionsCaadminV1ActionEvent>(IXC_CORPACTIONS_CAADMIN_V1_ACTION_EVENT_ENTITY_NAME, {
    event: new schema.Object({
        manualCreate: new schema.Object({
            securities: [ixcAssetsV1AssetStateEntity]
        })
    })
}, { idAttribute: (entity: IxcCorpactionsCaadminV1ActionEvent) => `${entity.metadata?.eventId}` });

